import React from 'react'

const Logo = ({style}) => {
  return (
    <img className={`w-[70px] h-[25px] ${style}`} src='./images/oridsan-logo.png' alt="oridsan logo" />

  )
}

export default Logo